var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"switch"},[_c('input',{class:[_vm.type],attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.checkinput},on:{"input":_vm.update}}),_c('span',{staticClass:"slider"})])])}
var staticRenderFns = []

export { render, staticRenderFns }